import { USER } from "../../pool";
import axiom from "../../utils/axiom";


export const ChangePasswordApiFromUrl = (details) =>
    axiom.patch(USER.base + USER.paths.updatePassword, details);
